export default "__VITE_ASSET__D$tPaQwY__"